import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api_url } from "../config/config";
import { useLocation } from "react-router-dom";
import axios from "axios"


const AddEmployee = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [roll, setRoll] = useState("");
  const [designation, setDesignation] = useState("");
  const [mobilenumber, setMobilenumber] = useState("");
  const [status, setStatus] = useState("Active");
  const [branchData,setBranchData] =useState([])
  const [branchId,setBranchId] = useState("")
  const location = useLocation();
  const { vendor } = location?.state || {};
  console.log("vendor from state",vendor);
  const fetchProductData = async () => {
    if (vendor) {
      setName(vendor.name);
      setEmail(vendor.email);
      setMobilenumber(vendor.mobile_number);
      setRoll(vendor.role);
      setStatus(vendor.isActive ? "Active" : "Inactive");
      setDesignation(vendor.designation);
      setBranchId(vendor.branch?.branch_id)
    }
  };

  useEffect(() => {
    fetchProductData();
  }, [id]);

  const validateForm = () => {
    if (!email.includes('@')) {
      alert('Please enter a valid email');
      return false;
    }
    if (mobilenumber.length !== 10) {
      alert('Mobile number must be exactly 10 digits');
      return false;
    }
    if(branchId === null || branchId === undefined || branchId === ""){
      console.log(branchId)
      alert("branch id is required");
      return false
    }
    return true;
  };

  const updateBasic = async () => {
    if (!validateForm()) {
      return; 
    }

    const payload = {
      name,
      email,
      mobile_number: mobilenumber,
      isActive: status === "Active" ? true : false,
      designation:designation,
      role: roll,
      branch_id:branchId
    };

    try {
      const response = await fetch(`${api_url}/admin/${id}`, {
        method: "PATCH",
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const result = await response.json();
        alert("Employee details successfully updated!");
      
        navigate("/ng-admin/employee");
      } else {
        const error = await response.json();
        alert("Failed to update employee details. Please try again.");
      }
    } catch (error) {
      console.error("Network Error:", error);
      alert("An error occurred while updating the employee details. Please try again.");
    }
  };

  const handleCancel = () => {
    navigate("/ng-admin/add-employee");
  };

  
      const fetchBranches = async () => {
      try {
        const response = await axios.get(`${api_url}/branches`);

        const rawBranches = response.data.results || [];

        const uniqueBranches = [
          ...new Map(
            rawBranches.map((branch) => [branch.branch_id, branch])
          ).values(),
        ];

        setBranchData(uniqueBranches);
        console.log("Unique Branches:", uniqueBranches);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };

    useEffect(() => {
      fetchBranches();
    }, []);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h2 className="text-2xl font-semibold mb-3">Edit Employee</h2>

      <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-lg p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <div className="mb-6">
              <h2 className="text-lg font-semibold mb-4">Basic Information</h2>
              <div className="mb-4">
                <label
                  htmlFor="productName"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="mb-4">
  <label
    htmlFor="email"
    className="block text-sm font-medium text-gray-700 mb-2"
  >
    Email
  </label>
  <input
    type="email"
    id="email"
    readOnly
    className="w-full border border-gray-300 rounded-lg p-3 bg-gray-100 cursor-not-allowed"
    value={email}
    onChange={(e) => setEmail(e.target.value)}
    required
  />
</div>

              <div className="mb-4">
              <label
                htmlFor="branch"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                Branch
              </label>
              <select
                id="branch"
                name="branch"
                className="w-full p-2 border border-gray-300 rounded-md"
                value={branchId}
                onChange={(e) => setBranchId(e.target.value)}
                required
              >
                <option value="">Select Branch</option>
                {branchData.map((branch) => (
                  <option key={branch.branch_id} value={branch.branch_id}>
                    {branch.area}
                  </option>
                ))}
              </select>
            </div>

              <div className="mb-4">
                <label
                  htmlFor="mobile_number"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Mobile Number
                </label>
                <input
                  id="mobile_number"
                  type="text"
                  maxLength="10"
                  className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500"
                  value={mobilenumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    if (value.length <= 10) {
                      setMobilenumber(value);
                    }
                  }}
                  required
                />
              </div>
                <div className="mb-4">
                <label
                  htmlFor="designation"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Designation
                </label>
                <input
                  type="text"
                  id="designation"
                  className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter Designation"
                  value={designation}
                  onChange={(e) => setDesignation(e.target.value)}
                  required
                />
              </div>
<div className="mb-4">
                <label
                  htmlFor="isActive"
                  className="block text-sm font-medium text-gray-700 mb-2"
                > 
                  Status
                </label>    
                <select
                  id="isActive"
                  name="status"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md"
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>
              <div className="mb-4">
                <label
                  htmlFor="role"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Role
                </label>
                <select
                  id="role"
                  value={roll}
                  onChange={(e) => setRoll(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md"
                >
                  <option value="employee">Employee</option>
                  <option value="admin">Admin</option>
                </select>
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  className="px-6 py-3 bg-[#3C1F1F] text-white font-semibold rounded-lg shadow-md"
                  onClick={updateBasic}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEmployee;
